import { Button, Group, Header } from "@vkontakte/vkui";
import {
  Icon24ArticleOutline,
  Icon24CrownOutline,
  Icon24HomeOutline,
  Icon24MarketOutline,
  Icon24UserOutline,
  Icon24UsersOutline
} from "@vkontakte/icons";
import type { AuthUser } from "@kass/shared";

type NavProps = {
  user: AuthUser | null;
  hasMembership?: boolean;
  hasPartnerAccess?: boolean;
  navigate: (path: string) => void;
};

export function MainNav({ user, hasMembership = false, hasPartnerAccess = false, navigate }: NavProps) {
  const role = user?.role || "guest";
  const isAdmin = ["super_admin", "member_manager", "partner_manager"].includes(role);
  const isPartner = hasPartnerAccess || role === "super_admin";

  return (
    <Group header={<Header>Навигация</Header>}>
      <div className="toolbar">
        <Button before={<Icon24HomeOutline />} mode="secondary" onClick={() => navigate("/")}>
          Главная
        </Button>
        <Button before={<Icon24MarketOutline />} mode="secondary" onClick={() => navigate("/partners")}>
          Партнёры
        </Button>
        <Button before={<Icon24CrownOutline />} mode="secondary" onClick={() => navigate("/leaderboard")}>
          Рекорды
        </Button>
        {hasMembership || role === "member" || role === "super_admin" ? (
          <Button before={<Icon24ArticleOutline />} mode="secondary" onClick={() => navigate("/membership")}>
            Карта
          </Button>
        ) : null}
        {user && role !== "guest" ? (
          <Button before={<Icon24UserOutline />} mode="secondary" onClick={() => navigate("/profile")}>
            Профиль
          </Button>
        ) : null}
        {isPartner ? (
          <Button before={<Icon24MarketOutline />} mode="secondary" onClick={() => navigate("/partner")}>
            Кабинет партнёра
          </Button>
        ) : null}
        {isAdmin ? (
          <Button before={<Icon24UsersOutline />} mode="secondary" onClick={() => navigate("/admin")}>
            Админка
          </Button>
        ) : null}
      </div>
    </Group>
  );
}
